import React from "react";
import {
  Addon,
  CBCustomer,
  EntityType,
  Subscription,
} from "../../../../api/grpc/subscription/subscription";
import { Currencies } from "../../../../lib/helpers/getCurrencySymbol";
import { hasUnlimitedUsersAddon } from "../../../../lib/helpers/hasUnlimitedUsersAddon";
import { totalBill } from "../../../../lib/helpers/totalBill";
import { NoAddons } from "./NoAddons";
import { SubscriptionItemsCount } from "./SubscriptionItemsCount";

import "./SubscriptionRow.scss";

export interface DetailsData {
  title: string;
  content: string | JSX.Element;
  className?: string;
}

interface Props {
  subscription?: Subscription;
  partnerData?: CBCustomer;
}

const getSubscriptionItems = (addons: Addon[]): Addon[] => {
  const firstUserAddon = addons.find(
    (item) => item.entityType === EntityType.USER
  );
  const firstUsersPackAddon = addons.find(
    (item) => item.entityType === EntityType.USERS_PACK
  );
  const totalUsers = addons.reduce(
    (total, item) =>
      item.entityType === EntityType.USER ||
      item.entityType === EntityType.USERS_PACK
        ? total + item.quantity
        : total,
    0
  );

  const items = addons
    .filter(
      (item) =>
        item.entityType !== EntityType.CROSS_ORG_ROOM_CALENDARS &&
        item.entityType !== EntityType.TOTAL_CARE_SUPPORT &&
        item.entityType !== EntityType.USERS_PACK &&
        (item.entityType !== EntityType.USER || item === firstUserAddon)
    )
    .map((item) =>
      item.entityType === EntityType.USER
        ? { ...item, quantity: totalUsers }
        : item
    );

  if (!firstUserAddon && firstUsersPackAddon) {
    return [
      ...items,
      {
        ...firstUsersPackAddon,
        name: "USER",
        entityType: EntityType.USER,
        quantity: totalUsers,
      },
    ];
  }

  return items;
};

export const SubscriptionItems = ({ subscription, partnerData }: Props) => {
  let definedStatus = [
    "cancelled",
    "active",
    "in_trial",
    "non_renewing",
  ].includes(subscription?.status.toLowerCase() || "");
  console.log(subscription, "subscription");
  const subscriptionAddons = subscription?.addons || [];
  const subscriptionItems = getSubscriptionItems(subscriptionAddons);
  const hasUnlimitedUsers = hasUnlimitedUsersAddon(subscriptionAddons);
  const addons =
    subscription?.addons.filter(
      (item) => item.entityType === EntityType.CROSS_ORG_ROOM_CALENDARS
    ) || [];

  const details: DetailsData[] = [
    {
      title: "Subscription Items",
      content:
        subscriptionItems.length > 0 ? (
          <SubscriptionItemsCount
            data={subscriptionItems}
            hasUnlimitedUsers={hasUnlimitedUsers}
          />
        ) : (
          "-"
        ),
    },
    {
      title: "Add-ons",
      content:
        addons.length > 0 ? (
          <SubscriptionItemsCount data={addons} showQuantity={false} />
        ) : (
          <NoAddons />
        ),
    },
    {
      title: "Billing status",
      content: !!partnerData?.email
        ? "Managed by Channel Partner"
        : subscription?.status?.toLowerCase() === "in_trial"
          ? `Free trial expires (${subscription?.billingStatus?.upcomingBillingAt})`
          : `Upcoming charges (${
              subscription?.billingStatus?.upcomingBillingAt
            }) ${totalBill(
              subscription?.billingStatus?.currency as Currencies,
              subscription?.billingStatus?.price || 0
            )}`,
      className: "span-block",
    },
  ];

  return (
    <div className="SubscriptionRow">
      <div className="SubscriptionRow__rows">
        {details.map((item: DetailsData) => (
          <div
            key={item.title}
            className={`SubscriptionRow__row ${definedStatus ? "" : "m-w-25"}`}
          >
            <h5>{item.title}</h5>
            <span
              className={`SubscriptionRow__row--content ${
                definedStatus
                  ? item.className
                  : `${item.className} ${item.className}--dual`
              }`}
            >
              {item.content}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
